import { FC } from 'react';
import { CatalogSize, Category, EcommercePlatform, SellingType } from './enums';
import {
  Package,
  DownloadImport,
  TShirt,
  Shipping,
  Coupon,
  HelpCircle,
  Checkroom,
  FaceFemale,
  Home,
  Toolbox,
  StandingArea,
  Bar,
  Library,
  AppMarket,
  Currency,
  App,
  Collections,
  Order,
  Cart,
  Globe,
  CreditCard,
  Receipt,
} from '@wix/wix-ui-icons-common';
import { Categories } from '@wix/ambassador-gg-store-setup-v1-store-setup-service/types';

export const sellingTypeItemProps: Record<SellingType, { icon: FC }> = {
  [SellingType.PhysicalProducts]: {
    icon: Package,
  },
  [SellingType.DigitalProducts]: {
    icon: DownloadImport,
  },
  [SellingType.PrintOnDemand]: {
    icon: TShirt,
  },
  [SellingType.Dropshipping]: {
    icon: Shipping,
  },
  [SellingType.Subscriptions]: {
    icon: Coupon,
  },
  [SellingType.Other]: {
    icon: HelpCircle,
  },
};

export const categoryItemProps: Record<Category, { icon: FC }> = {
  [Category.FashionApparel]: {
    icon: Checkroom,
  },
  [Category.BeautyPersonalCare]: {
    icon: FaceFemale,
  },
  [Category.HomeLiving]: {
    icon: Home,
  },
  [Category.ElectronicsGadgets]: {
    icon: Toolbox,
  },
  [Category.SportOutdoors]: {
    icon: StandingArea,
  },
  [Category.FoodBeverages]: {
    icon: Bar,
  },
  [Category.BooksMediaArt]: {
    icon: Library,
  },
  [Category.Other]: {
    icon: HelpCircle,
  },
};

export const catalogSizeItemProps: Record<CatalogSize, { icon: FC }> = {
  [CatalogSize.SingleProduct]: {
    icon: Currency,
  },
  [CatalogSize.FewProducts]: {
    icon: Collections,
  },
  [CatalogSize.SmallCollection]: {
    icon: App,
  },
  [CatalogSize.GrowingCatalog]: {
    icon: AppMarket,
  },
};

export const currentPlatformItemProps: Record<EcommercePlatform, { icon: FC }> = {
  [EcommercePlatform.Shopify]: {
    icon: Order,
  },
  [EcommercePlatform.Woo]: {
    icon: Cart,
  },
  [EcommercePlatform.Wordpress]: {
    icon: Globe,
  },
  [EcommercePlatform.Etsy]: {
    icon: AppMarket,
  },
  [EcommercePlatform.Square]: {
    icon: CreditCard,
  },
  [EcommercePlatform.Amazon]: {
    icon: Package,
  },
  [EcommercePlatform.BigCommerce]: {
    icon: Receipt,
  },
  [EcommercePlatform.Other]: {
    icon: HelpCircle,
  },
};

export const businessTermByCategory: Record<Category, Categories> = {
  [Category.FashionApparel]: {
    businessTermId: 'f0feda20-56ca-449a-bebb-20a4378c7c87',
    primary: 'Online Fashion Shop',
  },
  [Category.BeautyPersonalCare]: {
    businessTermId: 'db9e0824-d5c6-499a-b1d5-f37ae6ca04f9',
    primary: 'Beauty Shop',
  },
  [Category.HomeLiving]: {
    businessTermId: '947dfb4f-981a-495f-8b5c-df1790b39da9',
    primary: 'Ecom Home Goods Shop',
  },
  [Category.ElectronicsGadgets]: {
    businessTermId: '4fbcc175-3204-418b-8967-23af236b411b',
    primary: 'Electronics Shop',
  },
  [Category.SportOutdoors]: {
    businessTermId: 'd95ae26a-e340-4580-8311-0aa0b8fe2b11',
    primary: 'Sports Store',
  },
  [Category.FoodBeverages]: {
    businessTermId: 'e6629a08-4ce6-460b-8633-c49985718ef3',
    primary: 'Food Shop',
  },
  [Category.BooksMediaArt]: {
    businessTermId: 'b049e964-8377-4b10-b529-ed5a1e7b8977',
    primary: 'Bookstore',
  },
  [Category.Other]: {
    businessTermId: '6569ce47-806c-4a25-8000-03b0d8a79360',
    primary: 'Online Store',
  },
};
